import styled from 'styled-components';

export const CheckCardContainer = styled.div`
  .check-card {
    display: flex;
    align-items: center;
    padding: 0 13px;
    margin-bottom: 4px;
    min-height: 48px;

    &:hover {
      box-shadow: 0 1px 12px 0 rgba(0, 0, 0, 0.2);
      background: ${({ theme }) => theme.colors.weakBlue};
      cursor: pointer;
    }
  }

  .check-truck {
    > button {
      padding: 14px;
    }
  }
`;

export const Description = styled.span`
  font-size: ${({ theme }) => theme.fontSize.nm};
  color: ${({ theme }) => theme.colors.limedSpruce};
  max-width: 340px;
`;

export const Image = styled.img`
  margin-right: 20px;
  width: 30px;
  height: 30px;
`;

export const Price = styled.div`
  margin-left: 10px;
`;

export const AmountContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Amount = styled.div`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.colors.regent};
  margin-left: auto;
  margin-right: 15px;
  white-space: pre;

  & .balance {
    color: ${({ theme }) => theme.colors.color_green};
    font-weight: bold;
  }

  & .promo-amount {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.color_black};
  }
`;
